import React, { useEffect, useRef } from "react";
import DashboardEngine from "./dashboardEngine";
import "./dashboardData.css"; // Make sure you import your scoped CSS here

const NotebookJSONDashboard = ({ dashboardData }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current && dashboardData?.uiJson) {
      console.log("Rendering JSON dashboard...");
      DashboardEngine.initialize(containerRef.current, dashboardData);
    }
  }, [dashboardData]);

  return (
    <div>
      <h3>Notebook JSON Dashboard</h3>
      <div
        id="appRootJSON"
        className="dashboard-json"
        ref={containerRef}
        style={{
          border: "1px solid #ccc",
          minHeight: "400px",
          background: "#f9f9f9",
          padding: "10px",
        }}
      >
            <div id="dashboardContainer"></div>
      </div>
    </div>
  );
};

export default NotebookJSONDashboard;
